import * as Yup from 'yup';

export default Yup.object({
  password: Yup.string().required('Please enter a password'),
  confirmPassword: Yup.string().test(
    'passwords-match',
    'Passwords must match',
    function (value) {
      return this.parent.password === value;
    },
  ),
});
